import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import { dataFields } from './utils.js'

/**
 * Retorna os cadastros de uma equipe
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 *
 * @returns {Array}
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/desenvolvimento-infantil/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna os cadastros por microárea
 *
 * @param {*} cod_ibge
 * @param {*} nu_ine
 * @param {*} micro_area
 *
 * @returns {Array}
 */
export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/desenvolvimento-infantil/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Gera o relatório em PDF.
 *
 * @param {Array} cadastros
 * @param {Object} selectEquipe
 * @param {String} microArea
 * @param {Object} selectedFilterBoasPraticas
 */
export function generatePdf(
  cadastros,
  selectEquipe,
  microArea,
  selectedFilterBoasPraticas
) {
  let title_pdf = 'Desenvolvimento infantil'
  let titlePdfSave = utils.methods.titlePdf('Desenvolvimento infantil')

  let description_pdf = 'Cuidado no desenvolvimento infantil'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'M.ÁREA', 'PENDÊNCIAS']
  var data_pdf = []

  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) +
      `\n(${Math.floor(cadastros[i].idade_dias / 30)} ${
        Math.floor(cadastros[i].idade_dias / 30) > 1 ? 'meses' : 'mês'
      })`
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.pendencias = dataFields.Pendências.callback(cadastros[i])
    obj.rowColor = cadastros[i].rowColor
    data_pdf.push(obj)
  }

  let doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  let brasaoParaUsar = store.state.infoMunicipio.brasao

  utils.methods
    .fileToBase64(brasaoParaUsar)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
          {
            label: 'Boa prática',
            value: selectedFilterBoasPraticas?.label ?? '',
          },
        ],
        verticalPosition,
        'l'
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 12,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 12,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let color = data.row.raw[5]

          // Header sempre preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
            return
          }
          if (color == 'green') {
            doc.setTextColor(2, 99, 57)
            return
          }
          if (color == 'red') {
            doc.setTextColor(194, 10, 16)
            return
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 250, 600, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

/**
 * Percentual do município
 *
 * @param {Array} dadosDaTabelaResultado
 * @param {Object} selectedFilterBoasPraticas
 * @returns {Object}
 */
export function percentualMunicipio(
  dadosDaTabelaResultado,
  selectedFilterBoasPraticas
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  const dadosDoMunicipio = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 1 &&
      item.ibge === store.state.cod_ibge &&
      item.indicador == 51 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDoMunicipio.dados)

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
    classificacao = dados.classificacao
  } else {
    numerador = dados[`num_${selectedFilterBoasPraticas.key_percentual}`]
    denominador = dados.denominador
    resultado = dados[`res_${selectedFilterBoasPraticas.key_percentual}`]
    classificacao = '-'
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

/**
 * Percentual da equipe
 *
 * @param {Array} dadosDaTabelaResultado
 * @param {String} nuIne
 * @param {Object} selectedFilterBoasPraticas
 * @returns {Object}
 */
export function percentualEquipe(
  dadosDaTabelaResultado,
  nuIne,
  selectedFilterBoasPraticas
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaEquipe = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 2 &&
      item.ine === nuIne &&
      item.indicador == 51 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaEquipe === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDaEquipe.dados)

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
    classificacao = dados.classificacao
  } else {
    numerador = dados[`num_${selectedFilterBoasPraticas.key_percentual}`]
    denominador = dados.denominador
    resultado = dados[`res_${selectedFilterBoasPraticas.key_percentual}`]
    classificacao = '-'
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

/**
 * Percentual da equipe
 *
 * @param {Array} dadosDaTabelaResultado
 * @param {String} nu_ine
 * @param {String} micro_area
 * @param {Object} selectedFilterBoasPraticas
 * @returns {Object}
 */
export function percentualMicroArea(
  dadosDaTabelaResultado,
  nu_ine,
  micro_area,
  selectedFilterBoasPraticas
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaMicroArea = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 3 &&
      item.ine == nu_ine &&
      item.micro_area === micro_area &&
      item.indicador == 51 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaMicroArea === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: classificacao,
    }
  }

  let dados = JSON.parse(dadosDaMicroArea.dados)

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
    classificacao = dados.classificacao
  } else {
    numerador = dados[`num_${selectedFilterBoasPraticas.key_percentual}`]
    denominador = dados.denominador
    resultado = dados[`res_${selectedFilterBoasPraticas.key_percentual}`]
    classificacao = '-'
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

/**
 * Formata os cadastros com as doses de vacinas
 *
 * @param {Array} cadastros
 * @returns {Array}
 */
export function formatarCadastrosComDoses(cadastros) {
  return cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinas = {
      penta: JSON.parse(item.penta) ?? [],
      vip: JSON.parse(item.vip) ?? [],
      vpc10: JSON.parse(item.vpc10) ?? [],
      scr: JSON.parse(item.scr) ?? [],
    }

    const vacinaConfig = [
      {
        nome: 'coresPentaValente',
        vacina: 'penta',
        id_mn: '42',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
          { label: '3ª DOSE', id_ds: '3', idade: '6 meses' },
        ],
      },
      {
        nome: 'coresVip',
        vacina: 'vip',
        id_mn: '22',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
          { label: '3ª DOSE', id_ds: '3', idade: '6 meses' },
          { label: 'REFORÇO', id_ds: '38', idade: '15 meses' },
        ],
      },
      {
        nome: 'coresPneumococica',
        vacina: 'vpc10',
        id_mn: '26',
        doses: [
          { label: '1º DOSE', id_ds: '1', idade: '2 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '4 meses' },
          { label: 'REFORÇO', id_ds: '38', idade: '12 meses' },
          { label: 'ÚNICA', id_ds: '9', idade: '12 meses a 4 anos' },
        ],
      },
      {
        nome: 'coresSrc',
        vacina: 'scr',
        id_mn: '24',
        doses: [
          { label: '1ª DOSE', id_ds: '1', idade: '12 meses' },
          { label: '2ª DOSE', id_ds: '2', idade: '15 meses' },
          { label: 'DOSE', id_ds: '8', idade: '' },
        ],
      },
    ]

    const resultadoVacinas = vacinaConfig.reduce((acc, config) => {
      acc[config.nome] = processarDoses(
        vacinas[config.vacina],
        config.id_mn,
        config.doses,
        vacinasPendentes
      )
      return acc
    }, {})

    return {
      id: index,
      ...item,
      ...resultadoVacinas,
    }
  })
}

/**
 * Monta o objeto da dose
 *
 * @param {Object} vacina
 * @param {String|Number} id_mn
 * @param {Array} dosesConfig
 * @param {Array} vacinasPendentes
 * @returns {Array}
 */
function processarDoses(vacina, id_mn, dosesConfig, vacinasPendentes) {
  return dosesConfig.map(({ label, id_ds, idade }) => {
    const dose = encontrarDose(vacina, id_mn, id_ds, vacinasPendentes)

    return {
      dose: label,
      cor: dose.cor,
      tag: dose.tag || '',
      id_ds: dose.id_ds || '',
      id_mn: dose.id_mn || '',
      dt_plc: dose.tipo === 'aplicada' ? dose.dt_plc : idade,
      dt_plc_br: dose.tipo === 'aplicada' ? dose.dt_plc_br : idade,
      orig: dose.orig || '',
      lt: dose.lt || '',
    }
  })
}

/**
 * Procura um dose específica
 *
 * @param {Array} doses
 * @param {String} id_mn
 * @param {String} id_ds
 * @param {Array} vacinasPendentes
 * @returns {Object}
 */
function encontrarDose(doses, id_mn, id_ds, vacinasPendentes) {
  const aplicada = doses.find((el) => el.id_ds === id_ds && el.id_mn === id_mn)
  if (aplicada) {
    return {
      tipo: 'aplicada',
      cor: 'green',
      ...aplicada,
      dt_plc_br: aplicada.dt_plc?.split('-').reverse().join('/') || '',
    }
  }

  const pendente = vacinasPendentes?.find(
    (el) => el.id_ds === id_ds && el.id_mn === id_mn && el.na == '0'
  )
  if (pendente) {
    return {
      tipo: 'pendente',
      cor: 'red',
      ...pendente,
      dt_plc_br: '',
      orig: pendente.orig || '',
      lt: pendente.lt || '',
    }
  }

  return {
    tipo: 'pendente',
    id_ds: id_ds,
    id_mn: id_mn,
    cor: 'white',
    orig: '',
    lt: '',
  }
}
